import React from "react";

const AbmOptionsBus = (props) => {
  const options = [
    {
      text: 'What are ABM withdrawals?',
      handler: props.actionProvider.AbmBus1,
      id: 1
    },
    {
      text: 'How can it help my business?',
      handler: props.actionProvider.AbmBus2,
      id: 2
    },
    {
      text: 'How much can I charge for each ABM transaction?',
      handler: props.actionProvider.AbmBus3,
      id: 3
    },
    {
      text: 'What if someone used a stolen debit card to withdraw cash using my ABM?',
      handler: props.actionProvider.AbmBus4,
      id: 4
    },
    {
      text: 'I have questions around fees and installation. Where can I find more information?',
      handler: props.actionProvider.AbmBus5,
      id: 5
    },
    {
      text: 'Help, I’m having trouble with my ABM.',
      handler: props.actionProvider.AbmBus6,
      id: 6
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container debit-products'>{optionsMarkup}</div>;
};

export default AbmOptionsBus;